import React from 'react'
import { Card } from 'react-bootstrap'
import { useIntl } from 'react-intl'
// import OverviewChart from './OverviewChart';
import { PieChartWidget } from '../../widgets/components/General/PieChartWidget';
import NothingToShow from './NothingToShow';



const CaptableManagementChart = ({ title, data, colors }: { title: string, data: any, colors: any }) => {
    const { formatMessage } = useIntl()
    // const investors = [
    //     { name: "Aliza Shown", y: 3.8699 },
    //     { name: "Toshendra Shrma", y: 50 },
    //     { name: "John Wick", y: 40 },
    //     { name: "Rohendra Singh", y: 29.633 },
    //     { name: "Smith Jason", y: 17 },
    //     { name: "Remaining", y: 7 }
    // ];
    return (
        <Card className='w-100 p-4 bg-white'>
            <div>
                <p className='text-muted'>{formatMessage({ id: title })}</p>
            </div>
            {/* <OverviewChart dataPoints={investors} /> */}
            <div className='d-flex justify-content-center align-items-center h-100'>
                {data && data.length > 0 ?
                    <PieChartWidget
                        data={data}
                        colors={colors}
                    />
                    :
                    // <p>{formatMessage({ id: 'Nothing to Show' })}</p>
                    <NothingToShow />
                    // <NoDataPage />
                }
            </div>
        </Card>
    )
}
export default CaptableManagementChart



